import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import "../styles/MemberDetails.css";
import { FaRegUserCircle } from "react-icons/fa";
import {
  MdOutlineAssignmentInd,
  MdOutlineLocationOn,
  MdUpdate,
} from "react-icons/md";
import DetailsHeaderBar from "../components/DetailsHeaderBar";
import DetailsTopBar from "../components/DetailsTopBar";
import DetailSection from "../components/DetailSection";

function AdvertisingAgentDetails() {
  const location = useLocation();
  const agent = location.state?.agent;
  const navigate = useNavigate();

  if (!agent) {
    return <p style={{ padding: "30px" }}>No agent data available.</p>;
  }

  // Extract data from the nested structure
  const firstName = agent.first_name || agent.firstName || "N/A";
  const surname = agent.last_name || agent.surname || "N/A";
  const email = agent.email || "N/A";
  const mobile = agent.phone_number || agent.mobile || "N/A";
  const applicationId = agent.application_id || agent.id || "N/A";
  
  console.log("applicationId:", applicationId);
  // Handle address data
  const addressLine1 =
    agent.address_line1 || (agent.address && agent.address.line1) || "N/A";
  const addressLine2 =
    agent.address_line2 || (agent.address && agent.address.line2) || "N/A";
  const addressLine3 =
    agent.address_line3 || (agent.address && agent.address.line3) || "N/A";
  const city = agent.city || (agent.address && agent.address.city) || "N/A";
  const region =
    agent.region || (agent.address && agent.address.county) || "N/A";
  const country =
    (agent.countries && agent.countries[0]?.name) ||
    (agent.address && agent.address.country) ||
    agent.country ||
    "N/A";

  // Handle status
  const status = agent.current_status || agent.status || "N/A";
  const notes = agent.status_note || agent.notes || "No notes available";
  const referrer = agent.referred_by || "N/A";

  // Define all possible tabs
  const allTabs = [
    {
      key: "personal",
      label: "Personal Details",
      path: "/business-agent-details",
    },
    {
      key: "wallet",
      label: "Wallet Details",
      path: "/business-agent-wallet-details",
    },
    {
      key: "invitation",
      label: "Invitation Details",
      path: "/business-agent-invitation-details",
      showWhen: "approved",
    },
    {
      key: "request",
      label: "Promote / Demote",
      path: "/business-agent-request-history",
    },
  ];

  // Filter tabs based on status
  const getTabsByStatus = (agentStatus) => {
    return allTabs.filter((tab) => {
      if (!tab.showWhen) return true; // Always show tabs without conditions
      return tab.showWhen === agentStatus;
    });
  };

  // Usage
  const tabs = getTabsByStatus(agent.status);
  const goToEdit = () => {
     navigate("", { state: { agent } });
  };

  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
          title="Business Ads Agent Details"
          subtitle="You can edit your details to update your profile"
          breadcrumbs={[
            { label: "Home", path: "/dashboard" },
            {
              label: "Manage Business Ads Agent",
              path: "/manage-business-agent",
            },
            { label: "Business Ads Agent Details" },
          ]}
        />
        <DetailsTopBar tabs={tabs} activeTab="personal" agent={agent} />

        {/* Basic details */}
        <DetailSection
          title="Basic Details"
          icon={FaRegUserCircle}
          showEdit={true}
          onEdit={goToEdit}
          photoUrl={agent.photo_url || agent.profile_picture || agent.profile_image || agent.profile_photo || agent.avatar}
          fields={[
            { label: "First name", value: firstName },
            { label: "Surname", value: surname },
            { label: "Email", value: email },
            { label: "Mobile", value: mobile },
            /* { label: "Application ID", value: applicationId } */
          ]}
        />

        {/* Address */}
        <DetailSection
          title="Address"
          icon={MdOutlineLocationOn}
          fields={[
            { label: "Address line 1", value: addressLine1 },
            { label: "Address line 2", value: addressLine2 },
            { label: "Address line 3", value: addressLine3 },
            { label: "City", value: city },
            { label: "Covering region", value: region },
            { label: "Country", value: country },
          ]}
        />

        {/* Status */}
        <DetailSection
          title="Status"
          icon={MdUpdate}
          fields={[
            { label: "Email Status", value: status },
            { label: "Notes", value: notes },
          ]}
        />

        {/* Referred by */}
        <DetailSection
          title="Referred By"
          icon={MdOutlineAssignmentInd}
          fields={[{ label: "Referrer", value: referrer || "N/A" }]}
        />
      </div>
    </div>
  );
}

export default AdvertisingAgentDetails;
